
export default {
    NoValue: 0,
    Currency: 1,
    Asset: 2
  };